// export {default as Search} from './modules/Search';
// export {default as Navigation} from './modules/Navigation';
// export {default as Map} from './modules/Map';
export {default as Slider} from './modules/Slider';
// export {default as Tooltip} from './modules/Tooltip';